"use client";
import M, { useState as a, useEffect as g } from "react";
import "./index.es9.js";
import "./index.es10.js";
import "./index.es11.js";
import "./index.es12.js";
import "./index.es13.js";
import "./index.es14.js";
import "./index.es15.js";
import "./index.es16.js";
import "./index.es17.js";
import U from "./index.es62.js";
import "./index.es27.js";
import "./index.es28.js";
import "./index.es19.js";
import "./index.es20.js";
import "./index.es21.js";
import "./index.es22.js";
import "./index.es23.js";
import "./index.es24.js";
import A from "./index.es25.js";
import { createChartOptions as O } from "./index.es70.js";
import "./index.es26.js";
import "./index.es29.js";
import "./index.es30.js";
import "./index.es31.js";
import "./index.es32.js";
import { chartDataForRegionsByYear as c } from "./index.es4.js";
const X = ({
  regionYearValues: i,
  regionsData: p,
  year: r,
  keyContext: s,
  units: t,
  unitsName: l,
  isDownload: u,
  indicator: o,
  onChartChange: f
}) => {
  const [h, b] = a(
    c(i, p, r, t)
  ), n = () => {
    const e = {
      currentUnits: t === "Absolute" ? "Amount" : "Percent",
      unitsName: l,
      chartBackgroundColor: U.colors["sand-5"],
      title: u ? o.title : ""
    };
    return typeof o.proportionalUnitsMinimum == "number" && t === "Proportional" && (e.suggestedMin = o.proportionalUnitsMinimum), typeof o.absoluteUnitsMinimum == "number" && t === "Absolute" && (e.suggestedMin = o.absoluteUnitsMinimum), O(e);
  }, [y, C] = a(
    n()
  );
  g(() => {
    b(
      c(i, p, r, t)
    ), C(n());
  }, [i, p, r, t]);
  const m = r ? "bar" : "line";
  return /* @__PURE__ */ M.createElement(
    A,
    {
      keyContext: `${s}-${m}-regions-by-year`,
      key: `${s}-${m}-regions-by-year`,
      data: h,
      type: m,
      options: y,
      onChartChange: f
    }
  );
};
export {
  X as default
};
//# sourceMappingURL=index.es161.js.map
